import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { DialogHost } from './components/ConfirmDialog';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
    <DialogHost />
  </React.StrictMode>
);
